import Axios from 'axios'

import { OAUTH_API } from '@/services/Configuration'

import { log, error } from '@/services/Log'

import { goToConfirmation } from '@/services/FramedCheckout/navigationServices'

import { getOrderWithPayments } from '@/services/FramedCheckout/orderServices'
import { purchaseEventGA } from '@/helpers'
import { heapPurchaseTracking } from '../thridPartyServices'

// TODO: !!WARNING!! finalizePendingOrder needs to be tested
export const finalizePendingOrder = async ({ orderId }) => {
  const order = await getOrderWithPayments({ orderId })
  if (order.payments?.length) {
    const finalizedExternalPayments = order.payments.filter((payment) => payment?.detail?.step === 'ACKNOWLEDGE' && isFinite(payment.amount) && payment.amount > 0)
    log('Finalized external payments', finalizedExternalPayments)
    const externallyPaidAmount = finalizedExternalPayments.reduce((paid, payment) => paid + (payment.amount || 0), 0)
    log('externallyPaidAmount', externallyPaidAmount)


    log('is externally paid amount >= to grand total? ', externallyPaidAmount, order.grandTotal, externallyPaidAmount >= order.grandTotal)
    if (isFinite(order.grandTotal) && order.grandTotal > 0 && externallyPaidAmount >= order.grandTotal) {
      log('from inside payment review and processing')
      try {
        // TODO: We need documentation regarding this API
        log('trying create order ', orderId)
        // TODO: Update to V3
        await Axios.post(`/internalapi/v1/checkout/order/${orderId}`)
        log('done creating order ', orderId)

      } catch (err) {
        if (err.type !== 'order_finalization_not_required') {
          log(err)
        }
      } finally {
        log('post transition order update')
        const postTransitionOrder = await getOrderWithPayments({ orderId })
        log(`order after payment ${JSON.stringify(postTransitionOrder)}`)
        try {
          const zip = postTransitionOrder?.billingAddress?.zip || postTransitionOrder?.billingAddress?.postalCode
          log('Sending order confirmation email', { orderId, zip })
          await Axios.post(`${OAUTH_API}/sf/order/${orderId}/${zip}`)
          log('Order confirmation email sent')
        } catch (err) {
          error(`Failed to send the order confirmation email ${err}`)
        }
        //heap
        try {
          await heapPurchaseTracking({order, lineItems: order?.lineItems || []})
        } catch (e) {
          //fail heap silently
        }
        //ga
        try {
          log(`Send purchaseEventGA ${JSON.stringify({ orderId, order, postTransitionOrder })}`)
          await purchaseEventGA({
            orderId,
            billingAddress: order.billingAddress,
            coupons: order?.coupons || [],
            totalDiscount: order.totalDiscount,
            lineItems: order.lineItems,
            shippingCost: order.shippingCostTotal,
            email: order.billingAddress.email,
            taxTotal: order.taxTotal,
            grandTotal: order.grandTotal,
            cartTotal: order.subtotal,
          })
        } catch (err) {
          error(`Failed to send conversion data to GA ${err}`)
        }
        if (postTransitionOrder?.status !== 'INCOMPLETE') {
          log('postTransitionOrder COMPLETE')
          goToConfirmation(orderId)
          await new Promise((res) => {
            // Safari would continue script execution immediately, causing redirection
            // to cart.php if we don't await here.
            setTimeout(() => {
              res(true)
            }, 10000)
          })
        }
      }
    }
  }
}